<div class="row mx-0 row-modal">
  <div class="col-12 col-lg-8 img-cropper-container">
    <image-cropper
      class="cropper"
      [imageChangedEvent]="imageChangedEvent"
      [imageFile]="imageFile"
      [maintainAspectRatio]="maintainAspectRatio"
      [containWithinAspectRatio]="containWithinAspectRatio"
      [aspectRatio]="aspectRatio"
      [resizeToWidth]="resizeToWidth"
      [cropperMinWidth]="cropperMinWidth"
      [onlyScaleDown]="true"
      [roundCropper]="false"
      [canvasRotation]="canvasRotation"
      [transform]="transform"
      [alignImage]="'left'"
      [style.display]="showCropper ? null : 'none'"
      format="png"
      (imageCropped)="imageCropped($event)"
      (imageLoaded)="imageLoaded()"
      (cropperReady)="cropperReady($event)"
      #cropper></image-cropper>
  </div>
  <div class="col-12 col-lg-4">
    <div class="logo-container row-img d-flex align-items-center justify-content-center p-3">
      @if (data?.image) {
        <img
          class="img-boundary"
          [class.img-uploaded-circle]="!isCreateProject"
          [class.img-square]="isCreateProject"
          [class.img-uploaded]="isCreateProject"
          [src]="data?.image"
          alt="Uploaded" />
      }
    </div>
    <div class="d-block pb-3">
      <p class="crop-label">Crop your profile image</p>
      <p class="text-muted"
        >Please crop your image using the<br />cropping tool to the left. When<br />you're happy with your selection,<br />click
        the save button.</p
      >
      <button type="button" class="btn btn-lg btn-danger" (click)="upload()">Save</button>
    </div>
  </div>
</div>
